import { TextField } from 'components/FinalForm/TextField';
import { CountrySelectField, StateSelectField } from 'components/FinalForm/AddressSelectFields';
import { USER_FIELD_MAX_LENGTHS } from 'constants/userFieldMaxLengths';
import { SelectContainer, SelectLabel } from '../styled';

type PersonalDetailsProps = {
  selectedCountry: string;
};

export const PersonalDetails = ({ selectedCountry }: PersonalDetailsProps) => {
  return (
    <>
      <TextField
        name="first_name"
        label="First Name"
        maxLength={USER_FIELD_MAX_LENGTHS.first_name}
      />
      <TextField name="last_name" label="Last Name" maxLength={USER_FIELD_MAX_LENGTHS.last_name} />
      <TextField name="address1" label="Address 1" maxLength={USER_FIELD_MAX_LENGTHS.address1} />
      <TextField name="address2" label="Address 2" maxLength={USER_FIELD_MAX_LENGTHS.address2} />
      <TextField name="city" label="City" maxLength={USER_FIELD_MAX_LENGTHS.city} />
      <SelectContainer>
        <SelectLabel>State</SelectLabel>
        <StateSelectField
          country={selectedCountry}
          name="state"
          maxLength={USER_FIELD_MAX_LENGTHS.state}
        />
      </SelectContainer>
      <TextField name="zipcode" label="Zip" maxLength={USER_FIELD_MAX_LENGTHS.zipcode} />
      <SelectContainer>
        <SelectLabel>Country</SelectLabel>
        <CountrySelectField
          name="country"
          maxLength={USER_FIELD_MAX_LENGTHS.country}
          usOnly={true}
        />
      </SelectContainer>
    </>
  );
};
